import React, { useEffect, useState } from 'react';
import {
    Avatar,
    Box,
    Card,
    CircularProgress,
    Stack,
    Typography,
    useTheme,
} from "@mui/material";
import { EmojiEventsRounded, WorkspacePremiumRounded } from "@mui/icons-material";
import { Report_corporateTopPersonnel } from "../../../network/api/report.api";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../helper/utils";

const MEDAL_COLORS = [
    { bg: '#ffd700', text: '#5c4300', label: 'رتبه اول (طلا)' },
    { bg: '#c0c0c0', text: '#3c3c3c', label: 'رتبه دوم (نقره)' },
    { bg: '#cd7f32', text: '#4a2500', label: 'رتبه سوم (برنز)' },
];

const _DashTopPersonnel = ({ corporateId }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!corporateId) return;
        setLoading(true);
        Report_corporateTopPersonnel(corporateId)
            .then((res) => {
                setRows(res?.data?.Data?.Rows || []);
            })
            .catch(() => setRows([]))
            .finally(() => setLoading(false));
    }, [corporateId]);

    return (
        <Card
            elevation={0}
            sx={{
                p: { xs: 2, sm: 2.5 },
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 2 }}>
                <Box
                    sx={{
                        width: 38,
                        height: 38,
                        borderRadius: 2.5,
                        bgcolor: 'rgba(255, 215, 0, 0.15)',
                        color: '#d4af37',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <EmojiEventsRounded sx={{ fontSize: 22 }} />
                </Box>
                <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                        ورزشکاران برتر ماه (۳ نفر اول)
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        پرسنل با بیشترین دفعات حضور ورزشی در ماه جاری
                    </Typography>
                </Box>
            </Box>

            {loading ? (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1 }}>
                    <CircularProgress size={30} />
                </Box>
            ) : rows.length === 0 ? (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                        هنوز رکوردی برای ورزشکاران برتر این ماه ثبت نشده است.
                    </Typography>
                </Box>
            ) : (
                <Stack spacing={1.5} sx={{ my: 'auto' }}>
                    {rows.slice(0, 3).map((person, idx) => {
                        const medal = MEDAL_COLORS[idx] || MEDAL_COLORS[2];
                        return (
                            <Box
                                key={person.PersonnelId || idx}
                                onClick={() => {
                                    if (person.PersonnelId) {
                                        navigate(`/personnel/detail/${encodeId(person.PersonnelId)}`);
                                    }
                                }}
                                sx={{
                                    p: 1.5,
                                    borderRadius: 3,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    bgcolor: 'action.hover',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    cursor: person.PersonnelId ? 'pointer' : 'default',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        borderColor: 'primary.main',
                                        bgcolor: 'action.selected',
                                        transform: 'translateX(-4px)',
                                    },
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                    <Box
                                        sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: '50%',
                                            bgcolor: medal.bg,
                                            color: medal.text,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontWeight: 900,
                                            fontSize: '0.85rem',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                        }}
                                    >
                                        {idx + 1}
                                    </Box>
                                    <Box>
                                        <Typography variant="body2" sx={{ fontWeight: 800 }}>
                                            {person.FullName || "پرسنل ناشناس"}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {medal.label}
                                        </Typography>
                                    </Box>
                                </Box>

                                <Box sx={{ textAlign: 'left' }}>
                                    <Typography variant="h6" sx={{ fontWeight: 800, fontSize: '1.05rem', color: 'primary.main' }}>
                                        {person.Count || 0}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        جلسه حضور
                                    </Typography>
                                </Box>
                            </Box>
                        );
                    })}
                </Stack>
            )}
        </Card>
    );
};

export default _DashTopPersonnel;
